module.exports = __webpack_public_path__ + "static/media/payroll-plus.bbd65626.svg";